import 'core-js/modules/es6.promise'
import 'core-js/modules/es7.promise.finally'
import 'babel-polyfill'
import './global'
import './bootstrap'
import './scripts'
import './tippy'

import { EventBus } from './util/event-bus.js'

function loadPage () {
  const page = shiva.currentRouteName.replace('command-center.', '')
  const isSPA = shiva.spa || false

  if (isSPA) {
    import(`./sonic/${page}/main.js`)
  } else {
    if (page.lastIndexOf('expreso', 0) === 0) {
      // Expreso
    } else {
      switch (page) {
        case 'activation.showgoers.profile':
          import(`./blade/${page}`)
            .then(data => {
              EventBus.$emit('vue-page-ready', { page: page })
              $('body').trigger('vue-page-ready', { page: page })

              $('.y-loading').addClass('d-none')
            })
          break
        default:
          import(`./blade/default`)
            .then(data => {
              EventBus.$emit('vue-page-ready', { page: 'default' })
              $('body').trigger('vue-page-ready', { page: 'default' })

              $('.y-loading').addClass('d-none')
            })
      }
    }
  }

  $('[data-go-to]').click(function (e) {
    e.preventDefault()

    const id = $(this).attr('href')
    const offset = $(id).offset().top - $('#app').position().top + 10

    $('html, body').animate({
      scrollTop: offset
    }, 100)
  })
}

window.addEventListener('load', loadPage)



// WEBPACK FOOTER //
// ./resources/assets/command-center/js/app.js